import React from "react"
import { Player, BigPlayButton, ControlBar } from "video-react"
import { classNames } from "../../../../helpers/classNames"

// type GuideVideo = {
//   data: {
//         url: String
//         caption: { en: String, fi: String },
//         thumbnail: String,
//         videoFileId: String
//       },
//   list: Boolean,
//   preview: Boolean
//   preview: Boolean
// }

export const GuideVideo = ({ data, list, preview, full }) => {
  const classes = classNames({
    "video-container": true,
    list: list,
    preview: preview,
    fullsize: full
  })

  return (
    <div className={classes}>
      <Player src={data.url} className="video-player" height={preview ? 150 : 600} fluid={full ? false : true}>
        <BigPlayButton position="center" />
        <ControlBar disableCompletely={!full} />
      </Player>
    </div>
  )
}
